import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useInjectSaga, useInjectReducer } from '../store'

import taskManagementSaga from '../modules/task-management/store/saga'
import taskManagementReducer from '../modules/task-management/store/reducer'

import {
  loadTaskCategories,
  loadTaskUserList,
  loadAssigneeMyself,
  registerNewTask,
  loadTasks,
  loadMoreTasks,
  updateTask,
  deleteTask,
  deleteSelectedTasks,
  updateTaskOrder,
  updateSelectedTasks,
  loadUnreadTasks,
  updateStatusFilter
} from '../modules/task-management/store/actions'
import {
  makeSelectTaskCategories,
  makeSelectTaskUserList,
  makeSelectTasks,
  makeSelectUnreadTasks,
  makeSelectStatusFilter
} from '../modules/task-management/store/selectors'
import { DEFAULT_PAGE } from '../modules/task-management/constants'
import { ROUTES_NAME } from '../constants'
import { useProfile } from './profile'

export const useTaskManagement = () => {
  useInjectSaga({ key: 'taskManagementStore', saga: taskManagementSaga })
  useInjectReducer({ key: 'taskManagementStore', reducer: taskManagementReducer })

  const isCreateTask = window.location.pathname === ROUTES_NAME.CREATE_TASK
  const isEditTask = window.location.pathname.includes(ROUTES_NAME.EDIT_TASK)

  const dispatch = useDispatch()
  const { data: taskCategories, isLoading: isLoadingTaskCategories } = useSelector(makeSelectTaskCategories())
  const { data: userList, isLoading: isLoadingUserList } = useSelector(makeSelectTaskUserList())
  const { data: tasksData, isLoading: isLoadingTasks, isMoreLoading: isMoreLoadingTasks } = useSelector(makeSelectTasks())
  const { data: unreadTasks } = useSelector(makeSelectUnreadTasks())
  const statusFilter = useSelector(makeSelectStatusFilter())
  const loadTaskCategoriesAction = () => dispatch(loadTaskCategories())
  const loadTaskUserListAction = (payload) => dispatch(loadTaskUserList(payload))
  const loadAssigneeMyselfAction = (payload) => dispatch(loadAssigneeMyself(payload))
  const registerNewTaskAction = (payload) => dispatch(registerNewTask(payload))
  const loadTasksAction = (payload) => dispatch(loadTasks(payload))
  const loadMoreTasksAction = (payload) => dispatch(loadMoreTasks(payload))
  const updateTaskAction = (payload) => dispatch(updateTask(payload))
  const deleteTaskAction = (payload) => dispatch(deleteTask(payload))
  const deleteSelectedTasksAction = (payload) => dispatch(deleteSelectedTasks(payload))
  const updateTaskOrderAction = (payload) => dispatch(updateTaskOrder(payload))
  const updateSelectedTasksAction = (payload) => dispatch(updateSelectedTasks(payload))
  const loadUnreadTasksAction = () => dispatch(loadUnreadTasks())
  const updateStatusFilterAction = (payload) => dispatch(updateStatusFilter(payload))

  const [page, setPage] = useState(DEFAULT_PAGE.PAGE)

  // ログインユーザーを先頭にしたユーザーリストを作成
  const { profile: { userId } } = useProfile()
  const [sortedUserList, setSortedUserList] = useState(userList)
  useEffect(() => {
    const idx = userList.findIndex((user) => user.id === userId)
    if (idx !== -1) {
      const reordered = [
        userList[idx],
        ...userList.slice(0, idx),
        ...userList.slice(idx + 1)
      ]
      setSortedUserList(reordered)
    } else {
      setSortedUserList(userList)
    }
  }, [userList])

  return {
    isCreateTask,
    isEditTask,
    loadTaskCategoriesAction,
    loadTaskUserListAction,
    loadAssigneeMyselfAction,
    registerNewTaskAction,
    loadTasksAction,
    loadMoreTasksAction,
    updateTaskAction,
    deleteTaskAction,
    deleteSelectedTasksAction,
    updateTaskOrderAction,
    updateSelectedTasksAction,
    loadUnreadTasksAction,
    updateStatusFilterAction,
    statusFilter,
    taskCategories,
    userList,
    sortedUserList,
    tasksData,
    isLoadingTasks,
    isMoreLoadingTasks,
    isLoadingTaskCategories,
    isLoadingUserList,
    unreadTasks,
    page,
    setPage
  }
}
